import { Partner } from './helpers/types';

export const host = process.env.REACT_APP_API_HOST;
export const env = process.env.REACT_APP_ENV;

export const EXTRACTED: RegExp = /^[0-9]{4}-[a-zA-Z0-9]{5}-EXT[0-9]{1,}$/i;
export const BARCODE: RegExp = /^[0-9]{12,15}$/i;
export const BARCODE_READ: RegExp = /^[0-9]{5}-[0-9]{5}-[0-9]{5}|[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{2}$/i;

const getBaseURL = (prefix: string) => `${host}/${prefix}`;

export const getPartner = () => localStorage.getItem('partner') || Partner.CIRCLE;
export const getCustomerID = () => localStorage.getItem('customerId') || Partner.CIRCLE;
export const getRootUSer = () => localStorage.getItem('email') || '';

export const TASSCARE_LANGUAGE = ['en-VN', 'vi-VN'];

export const AUTH_API_BASE_URL = getBaseURL('authentication');

export const CUSTOMER_API_BASE_URL = getBaseURL('customer');

export const PROFILE_API_BASE_URL = getBaseURL('profile');

export const KIT_API_BASE_URL = getBaseURL('kit');

export const REPORT_API_BASE_URL = getBaseURL('report');

export const PARTNER_API_BASE_URL = getBaseURL('partner');

export const OTP_RESEND_TIME_INTERVAL = 60; // seconds

export const X_OWNER = 'X-Owner';

export const TAG = 'b2b_customer';

export const MIN_CUSTOMER_NAME_LENGTH = 2;

console.log('This is', env, host);